import { create } from 'zustand';

/**
 * Active platform support elevations for the signed-in user.
 *
 * Lives in a store rather than in the console's component tree because the
 * warning banner must render on EVERY route — including deep inside
 * /orgs/:orgId/meeting, far from anything the console renders.
 *
 * Hydrated from GET /api/platform/overview?only=elevations, and only ever
 * requested when the user is a platform admin.
 */
export const usePlatformElevationStore = create((set) => ({
  /** @type {Array<{auditId, organizationId, organizationName, expiresAt, reason}>} */
  elevations: [],
  loaded: false,

  setElevations: (elevations) => set({ elevations: elevations || [], loaded: true }),

  removeElevation: (organizationId) =>
    set((state) => ({
      elevations: state.elevations.filter((e) => e.organizationId !== organizationId),
    })),

  reset: () => set({ elevations: [], loaded: false }),
}));
